import React from "react";
import { Switch, Input, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import CustomCssTransition from "../../../components/UI/CustomCssTransition/customCssTransition";

import "../CustomUrl.css";

const Step3Panel = ({ thankYouPage, setThankYouPage }) => {
  return (
    <div>
      <div className="custom-url-field-group">
        <label className="custom-url-field-label">
          Custom Thank You Page
          <Tooltip title="Redirect customers to your own page after they complete booking.">
            <InfoCircleOutlined style={{ cursor: "pointer" }} />
          </Tooltip>
        </label>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Switch
            checked={thankYouPage.enabled}
            onChange={(checked) =>
              setThankYouPage({ ...thankYouPage, enabled: checked })
            }
          />
          <span style={{ fontSize: "13px", color: "#6b7280" }}>
            {thankYouPage.enabled ? "Enabled" : "Disabled"}
          </span>
        </div>
      </div>

      <CustomCssTransition
        in={thankYouPage.enabled}
        timeout={300}
        classNames="glimpse"
        unmountOnExit
      >
        <div className="custom-url-field-group">
          <label className="custom-url-field-label">Thank You Page URL</label>
          <Input
            placeholder="https://yoursite.com/thank-you"
            value={thankYouPage.url}
            onChange={(e) =>
              setThankYouPage({ ...thankYouPage, url: e.target.value })
            }
            style={{ width: "100%", borderRadius: "8px" }}
            allowClear
          />
          <p className="custom-url-field-helper">
            Customers will be redirected here after a successful booking.
          </p>
        </div>
      </CustomCssTransition>
    </div>
  );
};

export default Step3Panel;
